import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { UsersService } from '../../../../services/users.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-sendwebpush-settings',
    templateUrl: './sendwebpush.settings.html'
})
export class SendWebPushSettings extends FormulaWorkflowDialogContent {
    static ModuleID = 'sendwebpushWFModule';

    Users = [];
    Data = new SendWebPushSettingsData();

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = SendWebPushSettings.ModuleID;
        reg.Caption = '@@WebPush senden';
        reg.GroupID = 'wfActions';
        reg.Index = 45;
        reg.SettingsControl = SendWebPushSettings;
        reg.SettingsTypeHelper = new SendWebPushSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    AddAction() {
        this.Data.Actions.push(new WebPushAction());
    }

    DeleteAction(item) {
        const index = this.Data.Actions.indexOf(item, 0);
        if (index > -1) {
            this.Data.Actions.splice(index, 1);
        }
    }

    constructor(private service: UsersService) {
        super();
    }

    ngOnInit() {
        this.service.ReadUserInfos().subscribe(result => {
            if (result) {
                this.Users = result;
            }
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, SendWebPushSettingsData);
        }
    }

    getResult() {
        return this.Data;
    }
}

export class SendWebPushSettingsData {
    IndividualUsers: boolean = false;
    Users: [] = [];
    SenderEmail: string;
    Payload: string;
    Titel: string;
    Icon: string;
    Actions: WebPushAction[] = [];
}

export class WebPushAction {
    Action: string;
    Titel: string;
    Data: string;
    Icon: string;
}


export class SendWebPushSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new SendWebPushSettingsData();
    }
}
